// Regras de compressão de foto (spec S02 §Fotos: "compressão no aparelho
// ANTES de qualquer upload, alvo ~200 KB, lado maior 1600 px"). A chamada
// real ao `expo-image-manipulator` (API nativa, não testável em unit test)
// fica em ProjectPhotosSection; esta função isola a parte pura e testável —
// decidir SE e COMO redimensionar a partir das dimensões originais — para
// que a regra "lado maior 1600px" tenha cobertura de teste sem precisar
// mockar o manipulador nativo.

/** Alvo de qualidade JPEG passado a `manipulateAsync({ compress })`. Um
 * único valor fixo (não itera até bater ~200KB exato) — a spec pede um
 * "alvo" aproximado, não um tamanho exato; iterar até um byte-alvo exigiria
 * reler o arquivo comprimido e comprimir de novo em loop, complexidade não
 * pedida pela spec (YAGNI). */
export const PHOTO_COMPRESSION_QUALITY = 0.5;

/** Lado maior alvo em pixels, após redimensionar (spec: 1600px). */
export const MAX_PHOTO_SIDE_PX = 1600;

export interface ResizeAction {
  resize: { width?: number; height?: number };
}

/**
 * Decide a ação de resize do `expo-image-manipulator` a partir das
 * dimensões originais: reduz o lado maior para `maxSide`, preservando a
 * proporção (passa só width OU height — o manipulador calcula o outro lado
 * automaticamente). Retorna `null` quando a imagem já é menor ou igual ao
 * alvo (evita upscaling: fotos pequenas vindas da galeria não devem ser
 * ampliadas).
 */
export function buildResizeAction(width: number, height: number, maxSide: number = MAX_PHOTO_SIDE_PX): ResizeAction | null {
  const longSide = Math.max(width, height);
  if (longSide <= maxSide) {
    return null;
  }
  return width >= height ? { resize: { width: maxSide } } : { resize: { height: maxSide } };
}
